import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairAdditionalServiceToServer } from "./mappers/mapRepairAdditionalServiceToServer";
export const updateRepairAdditionalService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/update/service/additional`,
            method: "PUT",
            data: mapRepairAdditionalServiceToServer(service),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
